import * as React from 'react';

export const BingIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.85938 1.2002L8.94603 2.63976L8.95948 16.9755L14.6569 13.6548L11.8769 12.3542L10.093 7.92356L19.1373 11.0913L19.1299 15.7335L8.94487 21.6002L4.87266 19.3341L4.85938 1.2002Z"
        fill="url(#paint0_linear_12664_45300)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_12664_45300"
          x1="5.93795"
          y1="2.44308"
          x2="5.46119"
          y2="25.487"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#26B8F4" />
          <stop offset="1" stopColor="#1B48EF" />
        </linearGradient>
      </defs>
    </svg>
  );
};
